<template>
  <div>
    <article class="message is-marginless" v-if="show_download_app_notif" style="border-radius: 0;">
      <div class="message-body" style="padding: 5px 10px; border-radius: 0;">
        <div class="columns is-mobile is-gapless">
          <div class="column is-narrow">
            <a class="button is-text is-small" href="https://apps.apple.com/app/edlink/id1482222769">
              <span class="icon"><b-icon icon="cellphone-iphone"></b-icon></span>
              <span>Unduh versi iOS</span>
            </a>
          </div>
          <div class="column">
            <a class="button is-text is-small" href="https://play.google.com/store/apps/details?id=id.co.sevima.edlink">
              <span class="icon"><b-icon icon="cellphone-android"></b-icon></span>
              <span>Unduh versi Android</span>
            </a>
          </div>
          <div class="column is-narrow">
            <a class="button is-text is-small" @click.prevent="show_download_app_notif = false"><span class="icon"><b-icon icon="close" size="is-small"></b-icon></span></a>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  watch: {
    show_download_app_notif(val) {
    }
  },

  data() {
    return {
      show_download_app_notif: true
    }
  }
}
</script>

<style>

</style>
